import { DateTime } from "luxon";

/**
 * The collectedOn to send when marking a lead collected, or undefined to let the API stamp the
 * current time. The API stores a bare date as midnight UTC, which shows as 01:00 and used to become
 * every waste receipt's received time, so a bare date is only sent to backdate to an earlier
 * scheduled day.
 */
export function collectedOnForMarkCollected(
  scheduledCollectionOn: string | null | undefined,
  now: DateTime = DateTime.now()
): string | undefined {
  if (!scheduledCollectionOn) return undefined;

  const scheduled = DateTime.fromISO(scheduledCollectionOn);
  if (!scheduled.isValid || scheduled.startOf("day") >= now.startOf("day")) return undefined;

  return scheduled.toISODate() ?? undefined;
}
